export enum ProductionOrderType {
  CARPET = 'CARPET',
  WEAVING = 'WEAVING',
  TUFTING = 'TUFTING',
  PLASTIC = 'PLASTIC'
}
